export default {
	invoice: {
		open: 'Open',
		date: 'Invoice Date',
		details: 'Invoice Details',
		journalText: 'Journal Text',
		received_at: 'Received On',
		buildingId: 'Building ID',
		amounts: 'Amounts',
		total_amount: 'Invoice Amount',
		recognized_amount: 'Recognized Amount',
		approved_amount: 'Approved Amount',
		approved_total_amount: 'Approved Total Amount',
		due_date: 'Due Date',
		ledgerAccount: 'Ledger Account',
		approvedOn: 'Approved on',
		fiscalYear: 'Fiscal Year',
		purpose: 'Purpose of Use',
		invoiceItems: 'Invoice Items',
		item: 'Line item | Line items',
		subInvoice: 'Sub-invoice | Sub-invoices',
		approved: 'Approved',
		hide: 'Hide',
		show: 'Show',
		noPreview: 'No preview available',
	},
}
